const seedrandom = require('seedrandom');

export const randomElement = <T>(arr: T[], seed?: string): T => arr[randomInt(arr.length, seed)];

/**
 * Creates a random index between 0 and n-1.
 * @param n 
 * @param seed If you want to get the same random index every time, you can provide a seed.
 * @returns 
 */
export const randomInt = (n: number, seed?: string) => {   
    const rng = seed ? seedrandom(seed) : Math.random;
    const result = Math.floor(rng() * n);
    // console.debug("randomInt", {n, seed, result});
    return result;
}
// (window as any).randomInt = randomInt;
